import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals/attribution'

import { meter } from './metrics'

const lcp = meter.createHistogram('webvitals.lcp')
const inp = meter.createHistogram('webvitals.inp')
const cls = meter.createHistogram('webvitals.cls')
const ttfb = meter.createHistogram('webvitals.ttfb')
const fcp = meter.createHistogram('webvitals.fcp')

const baseAttrs = (route?: string) => {
  return {
    route: route || location.pathname || '/',
    navigation_type: (performance as any).navigation?.type ?? 'unknown',
    is_first_load: document.visibilityState === 'visible' ? '1' : '0',
    effective_connection_type:
      (navigator as any).connection?.effectiveType || 'unknown',
    device_memory: String((navigator as any).deviceMemory || '')
  }
}

export const initWebVitals = (getRoute?: () => string) => {
  const route = () => (getRoute ? getRoute() : undefined)

  onLCP((m) => {
    lcp.record(m.value, {
      ...baseAttrs(route())
    })
  })

  onINP((m) => {
    inp.record(m.value, {
      ...baseAttrs(route())
    })
  })

  onCLS((m) => {
    cls.record(m.value, {
      ...baseAttrs(route())
    })
  })

  onTTFB((m) => {
    ttfb.record(m.value, {
      ...baseAttrs(route())
    })
  })

  onFCP((m) => {
    fcp.record(m.value, {
      ...baseAttrs(route())
    })
  })
}
